import React from "react";

import { ConstraintsView } from "./ConstraintsView";

function ConstraintsSettings() {

    return (
        <div className="container-fluid">
            <div className="mb-4">
                <ConstraintsView />
            </div>
        </div>
    );
}

export { ConstraintsSettings };